import './ErrorMessage.scss';
import React, { type CSSProperties } from 'react';
import cx from 'classnames';

type ErrorMessageProps = {
    message?: string;
    className?: string;
    style?: CSSProperties;
    children?: any
};

const ErrorMessage: React.FC<ErrorMessageProps> = ({
    message,
    className,
    children,
    style
}) => (
    <p
        data-testid="error-message"
        className={cx('b-error-message', className)}
        style={style}
    >
        {message || children}
    </p>
);

export { ErrorMessage };

export default ErrorMessage;
